import React from 'react'
import styled from '@emotion/styled'
import ListItem from 'src/components/atoms/policy/ListItem'

const ListOl = ({ children }) => {
  const listItems = [...children].map(ele => {
    return <ListItem>{ele}</ListItem>
  })
  return <List>{listItems}</List>
}

const List = styled.ol`
  padding: 14px 0 14px 20px;
  list-style-type: decimal;
`
export default ListOl
